import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';
import { sendGetAuthAccountDataRequest } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { t } from 'utils/translates';

import DefaultSelect from 'components/Common/Inputs/DefaultSelect';
import * as formatter from 'mt-react-common/utils/formatter';
import { getValueFromRefDataModules } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import TasksService from 'mt-react-common/modules/tasks/services/TasksService';

// import * as formatter from 'mt-react-common/utils/formatter';

// eslint-disable-next-line react/prefer-stateless-function
class TasksUpListForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autoUpTime: this.props.taskModel.autoLiftInterval || 10,
      queue:
        this.props.taskModel.autoLiftQueue !== null &&
        this.props.taskModel.autoLiftInterval
          ? this.props.taskModel.autoLiftQueue
          : 1000,
      errors: null
    };
  }

  setAutoLiftInterval = (interval, queue) => {
    this.props.setLoading(true);
    TasksService.setAutoLiftInterval(
      this.props.taskModel.id,
      interval,
      queue
    ).then(result => {
      if (result) {
        if (result.status === 200) {
          this.props.updateTask();
          this.props.addClientNotice({
            type: 'success',
            message: result.data.message
          });
        } else if (result.status === 422) {
          this.setState({ errors: _.groupBy(result.data, 'field') });
        } else if ([423, 403].includes(result.status)) {
          this.props.addClientNotice({
            type: 'danger',
            message: result.data.message
          });
        }
      }
      this.props.setLoading(false);
    });
  };

  liftTask = () => {
    this.props.setLoading(true);
    TasksService.liftTask(this.props.taskModel.id).then(result => {
      if (result) {
        if (result.status === 200) {
          this.props.updateTask();
          this.props.updateAccountInfo();
          this.props.addClientNotice({
            type: 'success',
            message: result.data.message
          });
        } else if ([400, 423, 403].includes(result.status)) {
          this.props.addClientNotice({
            type: 'danger',
            message: result.data.message
          });
        }
      }
      this.props.setLoading(false);
    });
  };

  render() {
    const hasError = field => this.state.errors && this.state.errors[field];
    const errorDesc = field => {
      if (hasError(field)) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {this.state.errors[field][0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    const costLiftTask = 2;
    return (
      <article className="panel panel-default">
        <div className="panel-heading text-center panel-inner-border-bottom">
          <div className="panel-title">
            <i className="fa fa-arrow-up m-r-4" />{' '}
            {t('Поднять задание в общем списке')}
          </div>
        </div>
        {this.props.taskModel.upListFastenNow ||
        this.props.taskModel.upListFastenByCategoryNow ? (
          <div className="panel-body">
            <p className="">{t('Доступно для незакрепленных заданий.')}</p>

            <p className="m-b-0">
              {t(
                'Ваше задание закреплено и уже находиться выше заданий в общем списке.'
              )}
            </p>
          </div>
        ) : (
          <React.Fragment>
            <div className="panel-body">
              <p className="">
                {t(
                  'Поднимайте задание по расписанию или разово, чтобы привлечь больше исполнителей.'
                )}
              </p>
              <p className="text-danger">
                {t(
                  '<strong>Внимание! </strong>Используйте услугу с осторожностью: автоподнятие работает, пока задание активно и есть средства на балансе. Отключить можно в любой момент.'
                )}
              </p>
              <p className="m-b-20 m-t-15 text-base title-line title-line_sm">
                {this.props.taskPlace > 0
                  ? t(`Ваше задание на {place} месте`, {
                      place: this.props.taskPlace
                    })
                  : t('Ваше задание не опубликовано')}
              </p>
              <button
                className="btn btn-block btn-primary m-b-5"
                type="button"
                onClick={this.liftTask}
              >
                {t('Поднять сейчас за {cost}', { cost: costLiftTask })}{' '}
                <i className="fa fa-rub" />
              </button>
              <p className="m-b-20 m-t-20 text-base title-line title-line_sm">
                {t('или поднимать по расписанию')}
              </p>
              <div className="row">
                <div className="col-xs-24 col-sm-8">
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="liftTaskIntervalInput"
                    >
                      {t('Интервал')}:
                    </label>
                    <DefaultSelect
                      id={'liftTaskIntervalInput'}
                      selectTitleNullValue={null}
                      btnClassName={
                        'bs-placeholder btn btn-default dropdown-toggle'
                      }
                      selectArrItems={this.props.taskIntervalAutoLift}
                      value={this.state.autoUpTime}
                      handleChangeValue={value => {
                        this.setState({ autoUpTime: value });
                      }}
                    />
                  </div>
                </div>
                <div className="col-xs-24 col-sm-8">
                  <div className="form-group">
                    <label className="control-label" htmlFor="none">
                      {t('Количество поднятий')}:
                    </label>
                    <input
                      className="form-control ng-untouched ng-pristine ng-valid"
                      type="number"
                      min="1"
                      max="1000"
                      value={this.state.queue}
                      onChange={e => {
                        if (hasError('auto_lift_queue')) {
                          const errors = this.state.errors.auto_lift_queue;
                          delete errors.auto_lift_queue;
                          this.setState({ queue: e.target.value, errors });
                        } else {
                          this.setState({ queue: e.target.value });
                        }
                      }}
                    />
                    {errorDesc('auto_lift_queue')}
                  </div>
                </div>
                <div className="col-xs-24 col-sm-8">
                  <div className="form-group">
                    <label className="control-label" htmlFor="none">
                      {t('Бюджет')}: {this.state.queue * costLiftTask}{' '}
                      <i className="fa fa-rub" /> /{' '}
                      {formatter.formattedMinutes(
                        this.state.autoUpTime * this.state.queue
                      )}
                    </label>
                    <button
                      className="btn btn-block btn-primary"
                      onClick={() =>
                        this.setAutoLiftInterval(
                          this.state.autoUpTime,
                          this.state.queue
                        )
                      }
                      disabled={
                        this.state.autoUpTime ===
                          this.props.taskModel.autoLiftInterval &&
                        this.state.queue === this.props.taskModel.autoLiftQueue
                      }
                    >
                      {t('Применить')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="panel-footer">
              <div className="row">
                <div className="col-sm-16 col-xs-24">
                  {this.props.taskModel.liftAt ? (
                    <div className="text-muted form-control-static">
                      {t('Задание поднималось')}:{' '}
                      <strong>
                        {formatter.dateFormat1(this.props.taskModel.liftAt)}
                      </strong>
                    </div>
                  ) : (
                    <div className="text-muted form-control-static">
                      {t('Задание не поднималось')}
                    </div>
                  )}
                </div>
                <div className="col-xs-24 col-sm-8">
                  {this.props.taskModel.autoLiftInterval ? (
                    <button
                      className="btn btn-block btn-danger"
                      type="button"
                      onClick={() => this.setAutoLiftInterval(null)}
                    >
                      {t('Отключить автоподнятие')}
                    </button>
                  ) : (
                    <button
                      className="btn btn-block btn-muted"
                      type="button"
                      disabled
                    >
                      {t('Автоподнятие отключено')}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </article>
    );
  }
}

TasksUpListForm.contextTypes = {
  router: PropTypes.shape()
};

TasksUpListForm.defaultProps = {
  taskPlace: 0
};

TasksUpListForm.propTypes = {
  // IN
  updateTask: PropTypes.func.isRequired,
  taskModel: PropTypes.shape({
    id: PropTypes.number,
    autoLiftInterval: PropTypes.string,
    autoLiftQueue: PropTypes.string,
    upListFastenNow: PropTypes.shape({
      andTime: PropTypes.string
    }),
    upListFastenByCategoryNow: PropTypes.shape({
      andTime: PropTypes.string
    }),
    liftAt: PropTypes.string
  }).isRequired,
  setLoading: PropTypes.func.isRequired,
  // Connect
  updateAccountInfo: PropTypes.func.isRequired,
  addClientNotice: PropTypes.func.isRequired,
  taskIntervalAutoLift: PropTypes.string.isRequired,
  taskPlace: PropTypes.number
};

const mapStateToProps = state => ({
  taskIntervalAutoLift: getValueFromRefDataModules(
    state,
    'tasks.taskIntervalAutoLift'
  )
});

const mapDispatchToProps = dispatch => ({
  updateAccountInfo: () => dispatch(sendGetAuthAccountDataRequest()),
  addClientNotice: params => dispatch(addClientNotice(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TasksUpListForm);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksUpListPopUpNew/forms/TasksUpListForm.js